import React from "react";

import { MessageTemplateActions } from "../../../../../../types/MessageTemplateEnums";
import SMSStatusCellContent from "../components/SMSStatusCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function smsAwaitingPassengersStatus({
	width,
	onResize,
	language,
}: Column.Options) {
	return base(
		ColumnId.SMSAwaitingPassengersStatus,
		(item) => (
			<SMSStatusCellContent
				item={item}
				type={MessageTemplateActions.OUTPUT_PASSENGERS}
				language={language}
			/>
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default smsAwaitingPassengersStatus;
